(() => {
  let privacyApiPromise;

  function loadPrivacyApi() {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (privacyApiPromise) return privacyApiPromise;

    privacyApiPromise = new Promise((resolve, reject) => {
      if (!window.Shopify?.loadFeatures) {
        reject(new Error('Shopify Customer Privacy API is unavailable.'));
        return;
      }

      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        (error) => {
          if (error || !window.Shopify?.customerPrivacy) {
            reject(error || new Error('Shopify Customer Privacy API could not be loaded.'));
            return;
          }
          resolve(window.Shopify.customerPrivacy);
        }
      );
    });

    return privacyApiPromise;
  }

  function getDialog() {
    return document.querySelector('[data-piltron-cookie-dialog]');
  }

  function setBusy(dialog, busy) {
    dialog.querySelectorAll('[data-piltron-cookie-choice], [data-piltron-cookie-save], [data-piltron-cookie-accept]').forEach((control) => {
      control.disabled = busy;
    });
    dialog.setAttribute('aria-busy', String(busy));
  }

  function setStatus(dialog, message, isError = false) {
    const status = dialog.querySelector('[data-piltron-cookie-status]');
    if (!status) return;
    status.textContent = message;
    status.classList.toggle('piltron-cookie-dialog__status--error', isError);
  }

  function fillChoices(dialog, consent) {
    dialog.querySelectorAll('[data-piltron-cookie-choice]').forEach((input) => {
      input.checked = consent?.[input.value] === 'yes';
    });
  }

  async function openPreferences() {
    const dialog = getDialog();
    if (!dialog) return;

    setStatus(dialog, '');
    setBusy(dialog, true);
    if (!dialog.open) dialog.showModal();

    try {
      const privacyApi = await loadPrivacyApi();
      fillChoices(dialog, privacyApi.currentVisitorConsent());
      setBusy(dialog, false);
    } catch (error) {
      setStatus(dialog, dialog.dataset.loadError || 'تعذر تحميل إعدادات ملفات الارتباط.', true);
    }
  }

  async function savePreferences(dialog, acceptAll) {
    setBusy(dialog, true);
    setStatus(dialog, '');

    try {
      const privacyApi = await loadPrivacyApi();
      const consent = {};

      dialog.querySelectorAll('[data-piltron-cookie-choice]').forEach((input) => {
        consent[input.value] = acceptAll ? true : input.checked;
      });

      await new Promise((resolve) => privacyApi.setTrackingConsent(consent, resolve));
      fillChoices(dialog, privacyApi.currentVisitorConsent());
      setStatus(dialog, dialog.dataset.savedMessage || 'تم حفظ اختياراتك.');
      window.setTimeout(() => dialog.close(), 650);
    } catch (error) {
      setStatus(dialog, dialog.dataset.saveError || 'تعذر حفظ الاختيارات. حاول مرة أخرى.', true);
      setBusy(dialog, false);
    }
  }

  document.addEventListener('click', (event) => {
    const backLink = event.target.closest('[data-piltron-back-link]');
    if (backLink) {
      try {
        const referrer = document.referrer ? new URL(document.referrer) : null;
        if (referrer?.origin === window.location.origin && window.history.length > 1) {
          event.preventDefault();
          window.history.back();
        }
      } catch (error) {
        // Keep the storefront-home fallback when the referrer is unavailable.
      }
      return;
    }

    const trigger = event.target.closest('[data-piltron-cookie-preferences]');
    if (trigger) {
      event.preventDefault();
      openPreferences();
      return;
    }

    const dialog = event.target.closest('[data-piltron-cookie-dialog]');
    if (!dialog) return;

    if (event.target.closest('[data-piltron-cookie-close]')) {
      dialog.close();
      return;
    }

    if (event.target.closest('[data-piltron-cookie-save]')) {
      savePreferences(dialog, false);
      return;
    }

    if (event.target.closest('[data-piltron-cookie-accept]')) {
      savePreferences(dialog, true);
      return;
    }

    if (event.target === dialog) dialog.close();
  });
})();
